import { IconLoader } from '@ui/src';
import { BalanceFrsTypes } from './types';
import BalanceFrsItem from './frs-item';
import BalanceFrsRow from './frs-row';

import cn from './balance.module.css';

const BalanceFrs = ({ frs, isLoading }: BalanceFrsTypes) => {
  let content = (
    <div className={cn.reportLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading) {
    content = (
      <>
        <BalanceFrsItem
          title="Fixed assets"
          total={frs?.fixedAssets.total}
          right
        >
          <>
            <BalanceFrsRow
              title="Intangible assets"
              amount={frs?.fixedAssets.intangibleAssets}
              right
            />
            <BalanceFrsRow
              title="Property, plant, and equipment"
              amount={frs?.fixedAssets.propertyPlantEquipment}
              right
            />
          </>
        </BalanceFrsItem>
        <BalanceFrsItem
          title="Current assets"
          total={frs?.currentAssets.total}
          left
        >
          <>
            <BalanceFrsRow
              title="Debtors"
              amount={frs?.currentAssets.debtors}
              left
            />
            <BalanceFrsRow
              title="Investments"
              amount={frs?.currentAssets.investments}
              left
            />
            <BalanceFrsRow
              title="Cash and cash equivalents"
              amount={frs?.currentAssets.cash}
              left
            />
          </>
        </BalanceFrsItem>
        <BalanceFrsItem title="Creditors" total={frs?.creditors.total} left>
          <>
            <BalanceFrsRow
              title="Customer funds liabilities"
              amount={frs?.creditors.customerLiabilities}
              left
            />
            <BalanceFrsRow
              title="Amounts falling due within one year"
              amount={frs?.creditors.amountDueInOneYear}
              left
            />
          </>
        </BalanceFrsItem>
        <BalanceFrsItem
          title="Net Current Assets"
          total={frs?.netCurrentAssets.total}
          right
        />
        <BalanceFrsItem
          title="Total Assets less Current Liabilities"
          total={frs?.totalAssetsLessLiabilities.total}
          withHint
          right
        />
        <BalanceFrsItem
          title="Capital and Reserves"
          total={
            frs?.capitalAndReserves?.calledUpSharedCapital &&
            frs?.capitalAndReserves?.retainedEarnings
              ? (frs?.capitalAndReserves?.calledUpSharedCapital || 0) +
                (frs?.capitalAndReserves?.retainedEarnings || 0)
              : 0
          }
          right
        >
          <>
            <BalanceFrsRow
              title="Called up share capital "
              amount={frs?.capitalAndReserves.calledUpSharedCapital}
              right
            />
            <BalanceFrsRow
              title="Retained earnings"
              amount={frs?.capitalAndReserves.retainedEarnings}
              withHint
              right
            />
          </>
        </BalanceFrsItem>
        <BalanceFrsItem
          title="Shareholders Funds"
          total={frs?.shareholderFunds.total}
          right
          withHint
        />
      </>
    );
  }

  return (
    <>
      <div className={cn.frsHeader}>
        <div className={cn.frsHeaderValue}>Description</div>
        <div className={cn.frsHeaderValue}>Amount in BC</div>
        <div className={cn.frsHeaderValue}>Amount in BC</div>
      </div>
      {content}
    </>
  );
};

export default BalanceFrs;
